module.exports = __webpack_public_path__ + "images/internal/review_widgets/embeddable/controls_type/all.svg";